module.exports = __webpack_public_path__ + "static/img/Wayne-Pearce.7ecbd95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wayne-Pearce.jpg
// module id = Srps
// module chunks = 0